<script>
import { mapGetters } from 'vuex';
import QuestionStatement from '../components/QuestionStatement';
import ContributorPortrait from '../components/ContributorPortrait';

export default {
    name: 'ContributorQuestions',
    components: {
        QuestionStatement,
        ContributorPortrait
    },
    mounted() {
        this.init(this.$route.params.slug);
    },
    methods: {
        init(slug) {
            if (slug)
                this.$store.dispatch('selectContributorForAnswers', slug);
        },
        scrollToTop() {
            this.$scrollTo('#questionCloud', 950, { easing: [0.165, 0.84, 0.44, 1] })
        }
    },
    computed: {
        ...mapGetters({
            questions: 'getQuestionsOfContributor',
            contributor: 'getSelectedContributorAnswers',
            isLoading: 'getQuestionsIsLoading',
        }),
        contributorSlug() {
            return this.$route.params.slug;
        },
        baseUrl() {
            return this.$route.path.split('/')[1]
        }
    },
    beforeRouteUpdate(to, from, next) {
        this.$scrollTo('#contributor-questions', 950, { easing: [0.165, 0.84, 0.44, 1] })
        next();
    },
    beforeDestroy() {
        this.$store.dispatch('selectContributorForAnswers', null);
    },
};
</script>

<template>
    <div id="contributor-questions" class="contributor-questions">
        <div class="contributor-questions__content" v-if="!isLoading && questions">
            <a v-on:click="$router.go(-1)" class="contributor-questions__back-link" aria-label="zurück"></a>
            <h1 class="contributor-questions__title" v-html="$t('contributorQuestions.title') + ' ' + contributor.title.rendered"></h1>
            <div class="contributor-questions__portrait">
                <contributor-portrait 
                    v-bind:portrait="contributor" 
                    v-bind:prefix="$t('contributorQuestions.title')" 
                />
            </div>
            <div class="" v-for="(question) in questions" v-bind:key="question.ID">
                <span class="contributor-questions__question-title-wrapper">
                    <h2 class="contributor-questions__question-title page-title" v-html="question.title.rendered"></h2>
                </span>
                <template v-for="(statement, i) in question.statements"> 
                    <question-statement 
                        v-if="statement.contributor.post_name === contributorSlug"
                        v-bind:key="i"
                        v-bind:content="statement.content">
                    </question-statement>
                </template>
            </div>
        </div>
        <div class="contributor-questions__no-elements" v-if="!questions">{{ $t('contributorQuestions.noElements') }}</div>
    </div>
</template>

<style lang="scss" scoped>
.contributor-questions {
    @include container;
    @include page;
}
.contributor-questions__title-wrapper {
    position: relative;
}
.contributor-questions__title {
    display: none;
}
.contributor-questions__portrait {
    max-width: 40rem;
    margin-bottom: 11.2rem;
}
.contributor-questions__question-title {
    max-width: none;
    margin-left: 11.52rem;
    margin-bottom: 6.4rem;
    font-size: 4.4rem;

    @include breakpoint(sm-down) {
        margin-left: 0;
        margin-bottom: 5.76rem;
        margin-top: 4rem;
        font-size: 3.36rem;
    }
}
.contributor-questions__link-overview,
.contributor-questions__link-cloud {
    position: absolute;
    display: block;
    top: -0.96rem; left: 0.16rem;
    width: 5.6rem; height: 4.8rem;
    margin: 0;
    padding: 1.28rem 0;
    background: center url('~@/assets/images/ico-back-overview.svg') no-repeat transparent;
    cursor: pointer;
    z-index: 1;
    transition: transform 200ms;

    @include breakpoint('sm-down') {
        top: -5.12rem; left: 0rem;
        width: 3.36rem; height: 2.08rem;
        background-size: 3.36rem;
    }

    @include breakpoint('md-up') {
        &:hover {
            transform: translateX(-0.8rem);
        }
    }
}
.contributor-questions__link-cloud {
    transform: rotate(90deg) translate(0.24rem, 0.32rem);

    @include breakpoint('sm-down') {
        transform: rotate(90deg) translate(-0.32rem, 0.32rem);
    }

    @include breakpoint('md-up') {
        &:hover {
            transform: rotate(90deg) translate(-0.72rem, 0.32rem);
        }
    }
}
.question-statement {
    margin-bottom: 20rem;

    @include breakpoint(sm-down) {
        margin-bottom: 12.8rem;
    }
}
.contributor-questions__related-questions {
    @include row;
    margin-bottom: 16rem;

    @include breakpoint(sm-down) {
        margin-bottom: 0;
    }
}
.contributor-questions__related-questions__header {
    @include col;
    display: flex;
    width: calc(100% - #{$layout-gutter * 2});
    min-width: calc(100% - #{$layout-gutter * 2});
    justify-content: space-between;
    padding-bottom: 1.1rem;
    border-bottom: 0.1rem solid rgba($color-primary, 0.16);
}
.contributor-questions__related-questions__header__title {
    font-size: 1.8rem;
    margin: 0;
}
.question-card {
    @include col;
    width: calc(50% - 3.2rem);

    @include breakpoint("xs-down") {
        width: 100%;
    }
}

.contributor-questions__back-link {
    display: block;
    width: 5.6rem; height: 4.8rem;
    margin: 0 0 5.6rem;
    padding: 1.28rem 0;
    background: center url('~@/assets/images/ico-back-overview.svg') no-repeat transparent;
    cursor: pointer;
    z-index: 1;
    transition: transform 200ms;

    @include breakpoint('sm-down') {
        width: 3.36rem; height: 2.08rem;
        background-size: 3.36rem;
    }

    @include breakpoint('md-up') {
        &:hover {
            transform: translateX(-0.8rem);
        }
    }
}
</style>
